import { kanbanPropsSchema } from '../component-catalog.js';
export const kanbanDefinition = {
    type: 'Kanban',
    category: 'data',
    propsSchema: kanbanPropsSchema,
    isDataBacked: true,
    columnRefManifest: ['card', 'column', 'subtitle'],
    needsMeasuredDims: true,
    defaultHeight: 480,
    description: 'Card-based board grouped by a status column. Props: sourceDataset (required), mapping ({ card: string, column: string, subtitle?: string }).',
};
//# sourceMappingURL=Kanban.js.map